import { apiFetch } from './client';

export const leadsApi = {
  list: (filters = {}) =>
    apiFetch('/api/leads', {
      params: { campaign_id: filters.campaignId, status: filters.status, limit: filters.limit },
    }),
  get: (id) => apiFetch(`/api/leads/${id}`),
  create: (data) => apiFetch('/api/leads', { method: 'POST', body: data }),
  createBulk: (leads) => apiFetch('/api/leads/bulk', { method: 'POST', body: leads }),
  importCsv: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiFetch('/api/leads/import-csv', { method: 'POST', body: fd });
  },
  importExcel: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiFetch('/api/leads/import-excel', { method: 'POST', body: fd });
  },
  bulkCall: (leadIds, campaignId) =>
    apiFetch('/api/leads/bulk-call', {
      method: 'POST',
      body: { lead_ids: leadIds, campaign_id: campaignId },
    }),
  update: (id, patch) => apiFetch(`/api/leads/${id}`, { method: 'PUT', body: patch }),
  remove: (id) => apiFetch(`/api/leads/${id}`, { method: 'DELETE' }),
};
